
import {filter} from 'rxjs/operators';
import { Component, OnInit, HostListener } from "@angular/core";
import {
  Router,
  NavigationEnd,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  ResolveStart,
  ResolveEnd
} from "@angular/router";
import { Subscription } from "rxjs";
import { MediaObserver } from "@angular/flex-layout";
import { ThemeService } from "../../../services/theme.service";
import { LayoutService } from "../../../services/layout.service";

@Component({
  selector: "app-admin-layout",
  templateUrl: "./admin-layout.template.html",
  styleUrls: ["./admin-layout.css"]
})
export class AdminLayoutComponent implements OnInit {
  public isModuleLoading: Boolean = false;
  private moduleLoaderSub: Subscription;
  private layoutConfSub: Subscription;
  private routerEventSub: Subscription;
  private isMobile;
  public layoutConf: any = {};

  constructor(
    private router: Router,
    public themeService: ThemeService,
    private layout: LayoutService,
    private media: MediaObserver
  ) {
    // Close sidenav after route change in mobile
    this.routerEventSub = router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((routeChange: NavigationEnd) => {
        if (this.isSm()) {
          this.closeSidebar();
        }
      });


  }
  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    this.isMobile = this.isSm();
    this.layout.publishLayoutChange({
      isMobile: this.isMobile,
      sidebarStyle: this.isMobile ? "closed" : "full"
    });
    // FOR MODULE LOADER FLAG
    this.moduleLoaderSub = this.router.events.subscribe(event => {
      if (
        event instanceof RouteConfigLoadStart ||
        event instanceof ResolveStart
      ) {
        this.isModuleLoading = true;
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.isModuleLoading = false;
      }
    });
  }
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.isMobile = this.isSm();
    this.layout.publishLayoutChange({
      isMobile: this.isMobile,
      sidebarStyle: this.isMobile ? "closed" : "full"
    });
  }

  ngOnDestroy() {
    if (this.moduleLoaderSub) {
      this.moduleLoaderSub.unsubscribe();
    }
    if (this.layoutConfSub) {
      this.layoutConfSub.unsubscribe();
    }
    if (this.routerEventSub) {
      this.routerEventSub.unsubscribe();
    }
  }
  closeSidebar() {
    this.layout.publishLayoutChange({
      sidebarStyle: "closed"
    });
  }
  isSm() {
    return window.matchMedia(`(max-width: 959px)`).matches;
  }
}
